module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm sgc-1"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The authors would like to thank the extraordinary staff of the Boston Public Library for their generous help in locating photos and other materials for this project, as well as former "), _c('i', [_vm._v("Boston Herald")]), _vm._v(" photographer and investigator John Landers. The authors would also like to thank Jeff Saraceno at The History Press for “making us an offer we couldn’t refuse” and his patience during the process of putting this book together.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bee5018e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/acknowledgements.vue
// module id = 69
// module chunks = 0